export default __webpack_public_path__ + "static/media/Date_Img.979ed8fb.svg";